const scrollTo = (coordinates) => {
  $('html, body').animate({
    scrollTop: coordinates,
  }, 500);
}

export default scrollTo;
